<template>
  <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div>
  <form @submit.prevent="handleFilters">
    <div class="row filter-row">
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="employmentStatuses"
            placeholder="Select Status"
            id="design"
            v-model="filters.candidate_status"
          />
          <label class="focus-label">Candidate Status</label>
        </div>
        <i
          v-if="filters.candidate_status"
          @click="handleClearOneFilter('candidate_status')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="departments"
            v-model="filters.department"
            placeholder="Select Department"
            id="design2"
          />
          <label class="focus-label">Department</label>
        </div>
        <i
          v-if="filters.department"
          @click="handleClearOneFilter('department')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus text-truncate">
          <vue-select
            :options="designations"
            v-model="filters.designation"
            placeholder="Select Recruiter"
            id="design4"
          />
          <label class="focus-label">Designation</label>
        </div>
        <i
          v-if="filters.designation"
          @click="handleClearOneFilter('designation')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>

      <div class="col-md-9"></div>
      <div class="d-flex mb-2 col-sm-6 col-md-3 gap-2">
        <button
          type="submit"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="handleFilters"
        >
          Search
        </button>
        <button
          type="button"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="resetAllFilters"
        >
          Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import EmploymentStatusService from "@/services/EmploymentStatusService";
import DepartmentService from "@/services/DepartmentService";
import EmployeeService from "@/services/EmployeeService";
import RecruitmentRequisitionService from "@/services/RecruitmentRequisitionService";
import DutyTypeService from "@/services/DutyTypeService";
import DesignationService from "@/services/DesignationService";

export default {
  data() {
    return {
      select2: null,
      Company: ["Select Company", "Global Technologies", "Delta Infotech"],
      isFocused: false,
      filters: {
        candidate_status: "",
        department: "",
        designation: "",
      },

      isFocusedOn: false,
      employmentStatuses: ['done_interview','cancel_interview', 'scheduled_interview', 'hire_candidate', 'reject_candidate','on_hold','blacklist'].map((el) => { return {id: el, text: el.replace(/_/g, ' ')}}),
      departments: [],
      designations: [],
      jobs: [],
      priorities: ["low", "medium", "high"],
      searched: false,
    };
  },
  props: {},
  methods: {
    handleFilters(value) {
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      this.$emit("apply-filters", this.filters);
      // Perform any action on change
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      // Emit updated filters
      this.$emit("apply-filters", this.filters);

      // Reset search state
      this.searched = false;
    },

    // async fetchEmploymentStatuses() {
    //   try {
    //     const response = await DutyTypeService.fetch();
    //     this.employmentStatuses = response?.data.map((el) => el.duty_type);
    //   } catch (error) {
    //     console.error("Error fetching employment statuses:", error);
    //   }
    // },
    async fetchRecruiters() {
      try {
        const response = await DesignationService.getDesignations();
        this.designations = response?.data.map((el) => el.designation_name);
      } catch (error) {
        console.error("Error fetching designations:", error);
      }
    },
    async fetchJobs() {
      try {
        const response = await RecruitmentRequisitionService.fetch();
        this.jobs = response?.data.map((el) => el.job_title);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async fetchDepts() {
      try {
        const response = await DepartmentService.getDepartments();
        this.departments = response?.data.map((el) => el.name);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        candidate_status: "",
        department: "",
        designation: "",
      };
      this.searched = false;
    },
    async fetchServices() {
      try {
        // this.fetchEmploymentStatuses();
        this.fetchRecruiters();
        this.fetchJobs();
        this.fetchDepts();
      } catch (error) {
        console.log("error fetching services", error);
      }
    },
  },
  created() {
    this.searched = false;
    this.fetchServices();
    // this.campaigns = (await CampaignService.getCampaigns())?.data.map(
    //   (el) => el.campaigns
    // );
    // this.projects = (await EmployeeProjectService.fetch())?.data.map(
    //   (el) => el.project_name
    // );
    // this.sections = (await SectionService.getSections())?.data.map(
    //   (el) => el.section_name
    // );

    // through ID
    // this.designations = (await DesignationService.getDesignations()).data.map(el => ({id: el.id, text: el.designation_name}));
    // this.divisions = (await DivisionService.getDivisions()).data.map(el => ({id: el.id, text:el.name}));

    // this.campaigns = (await CampaignService.getCampaigns()).data.map(el => ({id:el.id, text: el.campaigns}));
    // this.sections = (await SectionService.getSections()).data.map(el => ({id: el.id, text: el.section_name}));
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>
